// import { useSelector } from "react-redux";

// import Authentication from "../header/Authentication.js";
// import User from "../header/User.js";

const Header = () => {
  // const token = useSelector((state) => state.auth.token);

  return (
    <header className="absolute top-0 left-1/4 lg:left-1/2 right-0 px-12 my-6 h-[4.725rem] flex justify-end items-center gap-10">
      {/* <Search /> */}
      {/* {token ? <User /> : <Authentication />} */}
    </header>
  );
};

export default Header;
